import { usePublicStyles } from "@/hooks/use-public-styles";

export function StylesProvider({ children }: { children: React.ReactNode }) {
  usePublicStyles();
  return <>{children}</>;
}
